<template>
  <div class="container">
    <div class="presonal-title">
      <span>{{ $t('lang.external.personal.content.two.实验报告') }}</span>
    </div>
    <transition-group name="slide-fade" mode="out-in">
      <Report
        key="report"
        v-if="view"
        @change="changeView"
        :data="experimentList"
      />
      <Correct key="correct" :data="isOver" v-else @change="changeView" />
    </transition-group>
  </div>
</template>

<script>
import Correct from '@/components/personalCenter/experimentalReport/correct.vue'
import Report from '@/components/personalCenter/experimentalReport/report.vue'
import { experimentReport } from '@/api/personalCenter/index'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'experimental-report',
  components: { Correct, Report },
  props: [],
  data() {
    return {
      view: true,
      isOver: undefined,
      experimentList: [],
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getExperiments()
  },
  mounted() {},
  methods: {
    changeView(val, data) {
      if (val) {
        this.view = val
      } else {
        this.view = val
        this.isOver = {
          id: data.id,
          status: data.status,
        }
        this.$store.commit(
          'SET_CRUMBS',
          this.$t('lang.external.personal.content.two.查看报告')
        )
      }
    },
    getExperiments() {
      experimentReport().then((res) => {
        const { data, current_page, per_page, total } = res.data
        let arrty = []
        for (let i = 0; i < data.length; i++) {
          data[i]['courseName'] = formatLan(data[i]['courseName'])
          arrty.push(data[i])
          console.log(data[i])
        }
        this.experimentList = arrty
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
</style>